export const MobileNavBarHeight = 75;
export const MobileDeviceBreakpoint = "lg";

export const ToastAutoHideDuration = 2500;
export const ToastMaxConcurrentNotifications = 2;

export const MaxAllowedNumberOfZonesToFollow = 5;

export const focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]';